import React from "react";
import { Col, Card, CardBody, Spinner, Button } from "reactstrap";
import { Link } from "react-router-dom";
import { MdArrowBack } from "react-icons/md";
import AccessControl from "../../../../shared/components/AccessControl";
import { permissionsConstants } from "../../../../constants/permission.constants";
// import { permissionsConstants } from "../../../../constants/permission.constants";

const { MANAGE_INSTITUTIONS } = permissionsConstants;
const ViewInstitutionPage = props => {
  const { institution, institutionId, fetchData } = props;

  const foundInstitution = institution.response && Object.keys(institution.response).length ? true : false;
    
  const institutionObj = {...institution.response}
   

  return (
    <Col>
      <Card>
        <CardBody>
          {foundInstitution ? (
            <div className="project-summary">
              <div className="card__title">
                <h4 className="bold-text">
                  {institutionObj.name}
                </h4>
              </div>
              <AccessControl
                allowedPermissions={[MANAGE_INSTITUTIONS]}
                renderNoAccess={() => null}
              >
                <Link
                  to={`/institution/edit/${institutionId}`}
                  className="btn btn-sm btn-outline-secondary project-summary__btn"
                  id="link-edit-user"
                >
                  Edit
                </Link>
              </AccessControl>

              <dl className="row">
                <dt className="col-sm-2">Name</dt>
                <dd className="col-sm-10">
                  <p>{institutionObj.name}</p>
                </dd>
            
                <dt className="col-sm-2">Fep Code</dt>
                <dd className="col-sm-10">
                  <p>{institutionObj.fepCode}</p>
                </dd>

                <dt className="col-sm-2">Domain Code</dt>
                <dd className="col-sm-10">
                  <p>{institutionObj.domainCode}</p>
                </dd>

                <dt className="col-sm-2">Subscriber Id</dt>
                <dd className="col-sm-10">
                  <p>{institutionObj.subscriberId}</p>
                </dd>

                {
                  institutionObj.adminEmail ?
                  <>
                  <dt className="col-sm-2">Admin Email</dt>
                <dd className="col-sm-10">
                  <p>{institutionObj.adminEmail}</p>
                </dd></> : ''
                }

                <dt className="col-sm-2">Created By </dt>
                <dd className="col-sm-10">
                  <p>{institutionObj.createdBy}</p>
                </dd>

                <dt className="col-sm-2">Created On </dt>
                <dd className="col-sm-10">
                  <p>{institutionObj.createdOn}</p>
                </dd>

                {institutionObj.lastUpdateBy && <><dt className="col-sm-2">Last Update By </dt>
                <dd className="col-sm-10">
                  <p>{institutionObj.lastUpdateBy}</p>
                </dd></>}

                {institutionObj.lastUpdateOn && <><dt className="col-sm-2">Last Update On </dt>
                <dd className="col-sm-10">
                  <p>{institutionObj.lastUpdateOn}</p>
                </dd></>}

              </dl>
            </div>
          ) : (
            <div className="text-center">
              {institution && institution.loading ? (
                <div>
                  <Spinner
                    color="success"
                    className="my-4"
                    style={{ width: "6rem", height: "6rem" }}
                  />
                  <h4 className="text-secondary">
                    Fetching institution with id ({institutionId})
                  </h4>
                </div>
              ) : (
                <div>
                  <h4 className="text-danger">
                    {institution.error
                      ? `Something went wrong. Could not fetch institution with id (${institutionId})`
                      : `Institution with id (${institutionId}) not found`}
                  </h4>
                  <Button
                    color="primary"
                    id="btn-try-again"
                    outline
                    size="sm"
                    onClick={fetchData}
                  >
                    Try Again
                  </Button>
                </div>
              )}
            </div>
          )}
          {institution && !institution.loading ? (
            <h5 className="bold-text mt-4">
              <Link to="/institution" id="link-all-users">
                <MdArrowBack size={20} /> Back to institutions
              </Link>
            </h5>
          ) : null}
        </CardBody>
      </Card>
    </Col>
  );
};

export default ViewInstitutionPage;
